var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_an-object.js
// module id = 3
// module chunks = 0 1 2 3 4